<template>
  <div>

  </div>
</template>

<script>
import auth from '../auth'
export default {
  name: 'Home',
  data () {
    return {
    }
  },
  methods: {
    logout () {
      auth.logout()
    }
  },
  created () {
    auth.checkAuth()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
